import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import ErrorPageImg from '../../../static/img/error-something-went-wrong.svg';

import './Error.scss';

class ErrorPage extends Component {
  code() {
    const code = (this.props.code || 'unspecified').toUpperCase();
    return `components.ecs.error.types.${code}`;
  }

  render() {
    return (
      <div className="error-page slds-grid slds-wrap slds-grid--align-center">
        <div className="slds-size--1-of-1 error-image">
          <img
            src={ErrorPageImg}
            alt="Data Unavailable: Something went wrong."
          />
        </div>
        <div className="slds-size--1-of-1">
          <h1 className="slds-page-header__title">
            <FormattedMessage id={this.code()} />
          </h1>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  code: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(ErrorPage);
